/**
 * @file load-messages.ts
 *
 * Lazily loads a locale's catalog from the shared `@wsb/i18n` package,
 * code-split per locale by webpack so the bundle only ships the active
 * language. Falls back to the default locale's catalog when one is missing.
 */

import { DEFAULT_LOCALE } from '@wsb/i18n';

// Static specifiers on purpose: webpack code-splits one chunk per literal and
// resolves it through @wsb/i18n's exports map; a template-literal import
// would need a fragile context module over the package boundary.
const CATALOGS: Record<string, () => Promise<{ default: Record<string, string> }>> = {
  'en-GB': () => import('@wsb/i18n/messages/en-GB.json'),
  'da-DK': () => import('@wsb/i18n/messages/da-DK.json'),
  'de-DE': () => import('@wsb/i18n/messages/de-DE.json'),
  'es-ES': () => import('@wsb/i18n/messages/es-ES.json'),
  'fi-FI': () => import('@wsb/i18n/messages/fi-FI.json'),
  'fr-FR': () => import('@wsb/i18n/messages/fr-FR.json'),
  'it-IT': () => import('@wsb/i18n/messages/it-IT.json'),
  'nl-NL': () => import('@wsb/i18n/messages/nl-NL.json'),
  'nb-NO': () => import('@wsb/i18n/messages/nb-NO.json'),
  'pt-PT': () => import('@wsb/i18n/messages/pt-PT.json'),
  'sv-SE': () => import('@wsb/i18n/messages/sv-SE.json'),
};

export async function loadMessages(
  locale: string,
): Promise<Record<string, string>> {
  const load = CATALOGS[locale] ?? CATALOGS[DEFAULT_LOCALE];
  try {
    return (await load()).default;
  } catch {
    return (await CATALOGS[DEFAULT_LOCALE]()).default;
  }
}
